module.exports = __webpack_public_path__ + "static/media/clinician-stroke-risk-factors-preview@2x.2bcf339b.png";